import { jwtContextFactory } from '@apps/checkout-contexts';

import type { UkJwtPayload } from '../../global.types';

const { JwtContextProvider, useJwtContext, withJwtContextProvider } =
  jwtContextFactory<UkJwtPayload>();

export { JwtContextProvider, useJwtContext, withJwtContextProvider };
